import HttpUtil from "ips/ac/util/HttpUtil";
import Util from "ips/ac/util/Util";
import MessageToast from "sap/m/MessageToast";
import View from "sap/ui/core/mvc/View";

export default class InvitationTokenMailService {

  public static async resendUserOnboardingMail(view: View, guid: string) {
    await InvitationTokenMailService.resendOnboardingMail(view, `${Util.getPrivateApi()}/resendOnboardingMail/user/${guid}`);
  }

  public static async resendClientOnboardingMail(view: View, guid: string) {
    await InvitationTokenMailService.resendOnboardingMail(view, `${Util.getPrivateApi()}/resendOnboardingMail/client/${guid}`);
  }

  private static async resendOnboardingMail(view: View, sUrl: string) {
    view.setBusy(true);

    try {
      await HttpUtil.post(sUrl, null, null);
      MessageToast.show(Util.getText("UserRegistrationResponse_MAIL_SENT"));
    } finally {
      view.setBusy(false);
    }
  }
}